export function validatePasswordStrength(value?: string) {
  const password = value || ''
  if (password.length < 10) return Promise.reject(new Error('密码至少 10 位'))
  if (!/[A-Za-z]/.test(password) || !/\d/.test(password)) {
    return Promise.reject(new Error('密码需同时包含字母和数字'))
  }
  return Promise.resolve()
}
